import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../authentication/authentication.service';
import { AUTHENTICATION_TOKEN_REFRESH } from '@core/constants/storage-keys';
import moment from 'moment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    isRefreshingToken = false;

    constructor(private authenticationService: AuthenticationService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let nextRequest = request.clone();

        if (this.authenticationService.token) {
            nextRequest = request.clone({
                setHeaders: {
                    'x-access-token': this.authenticationService.token,
                },
            });
            this.refreshToken().catch(() => {});
        }
        return next.handle(nextRequest);
    }

    private async refreshToken() {
        const refreshTimeValue = localStorage.getItem(AUTHENTICATION_TOKEN_REFRESH);
        const refreshTime = moment(refreshTimeValue ? Number(refreshTimeValue) : 0);

        if (refreshTime.isBefore(moment()) && !this.isRefreshingToken) {
            this.isRefreshingToken = true;
            await this.authenticationService.refreshToken();
            this.isRefreshingToken = false;
        } else {
            return Promise.resolve();
        }
    }
}
